import { supabase } from "@/lib/supabase";

export type AccentThemeId = "violet" | "rose" | "blue" | "green";

export const ACCENT_THEMES: { id: AccentThemeId; label: string; swatch: string }[] = [
  { id: "violet", label: "Violet", swatch: "#7c3aed" },
  { id: "rose", label: "Rose", swatch: "#e11d48" },
  { id: "blue", label: "Bleu", swatch: "#2563eb" },
  { id: "green", label: "Vert", swatch: "#059669" },
];

const DEFAULT_THEME: AccentThemeId = "violet";

function isAccentThemeId(value: unknown): value is AccentThemeId {
  return ACCENT_THEMES.some((theme) => theme.id === value);
}

export function applyAccentTheme(themeId: AccentThemeId) {
  if (typeof document === "undefined") return;
  document.documentElement.dataset.theme = themeId;
}

export async function fetchAccentTheme(userId: string): Promise<AccentThemeId> {
  if (!userId) return DEFAULT_THEME;

  const { data, error } = await supabase
    .from("user_preferences")
    .select("accent_theme")
    .eq("user_id", userId)
    .maybeSingle();

  if (!error && isAccentThemeId(data?.accent_theme)) {
    return data.accent_theme;
  }

  return DEFAULT_THEME;
}

export async function saveAccentTheme(userId: string, themeId: AccentThemeId): Promise<{ errorMessage?: string }> {
  const { error } = await supabase
    .from("user_preferences")
    .upsert({
      user_id: userId,
      accent_theme: themeId,
      updated_at: new Date().toISOString(),
    });

  if (error) {
    return { errorMessage: error.message };
  }

  return {};
}
